import { Navigate } from 'react-router'
import { useAuthStore } from '@/stores/authStore'
import { UserRole } from '@/types/enums'

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: UserRole[]
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, profile, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-3 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
          <p className="text-sm text-surface-500">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user || !profile) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && !allowedRoles.includes(profile.role as UserRole)) {
    switch (profile.role) {
      case UserRole.Admin:
        return <Navigate to="/admin/dashboard" replace />
      case UserRole.Agent:
        return <Navigate to="/agent/dashboard" replace />
      case UserRole.Client:
        return <Navigate to="/client/dashboard" replace />
      default:
        return <Navigate to="/login" replace />
    }
  }

  return <>{children}</>
}
